import {
    GetEventsByCityRequest,
    EventByCityItem,
    GetEventsByCityResponse,
    RawGetEventsByCityRequest,
} from 'api/events/events.types';
import {spotheroGet} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {convertKeysToSnakeCase} from 'utils/format-strings';

const formatGetEventsByCitiesRequest = (
    requestData: GetEventsByCityRequest
): RawGetEventsByCityRequest => {
    const formattedRequest = convertKeysToSnakeCase(requestData);

    return formattedRequest;
};

export type GetEventsByCitiesParams = {
    cityIds: number[];
    page: number;
    pageSize: number;
};

const getEventsByCities = async (
    requestData: GetEventsByCitiesParams,
    config = {}
): Promise<GetEventsByCityResponse> => {
    const formattedRequest = formatGetEventsByCitiesRequest({
        city: requestData.cityIds,
        page: requestData.page,
        pageSize: requestData.pageSize,
        camelize: true,
        include: 'destination',
    });

    try {
        const response = await spotheroGet<EventByCityItem[]>(
            `events/by-cities/`,
            formattedRequest,
            {
                paramsSerializer: {
                    indexes: null,
                },
                ...config,
            }
        );

        return response.data;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default getEventsByCities;
